import InboundButton from '@composites/InboundButton';
import PartnersSection from '@composites/PartnersSection';
import { safeJSONParse } from './fn';

export interface PageBuilderParams {
  mlsid: string;
  tagName?: string;
  className?: string;
}

export const TAG_NAMES = { DIV: 'div', BUTTON: 'button' } as const;
export const MLSID = {
  EXHIBITOR_GROUP: 'EXHIBITOR_GROUP',
  ATTENDEE_LIST_DOWNLOAD: 'attendeelist-download',
  AGENDA_DOWNLOAD: 'agenda-download',
  PARTNER_PROSPECTUS_DOWNLOAD: 'partner-prospectus-download',
  SAVE_THE_DATE: 'save-the-date',
  START_SURVEY: 'start-survey',
  VIDEO_CONTENT: 'video-content',
  MEDIA_PACKAGE_DOWNLOAD: 'media-package-download',
  WHITE_PAPER_DOWNLOAD: 'white-paper-download',
  PODCAST_CONTENT: 'podcast-content',
  WEBAPP_FREETICKET_ONSITE: 'webapp-freeticket-onsite',
} as const;

export const COMPONENT_MAP: Record<
  string,
  {
    component: React.FC<any>;
    getProps: (attributes: Record<string, string>) => Record<string, any>;
  }
> = {
  [MLSID.EXHIBITOR_GROUP]: {
    component: PartnersSection,
    getProps: attributes => ({ groupId: attributes.selectedgroupid }),
  },
  [MLSID.ATTENDEE_LIST_DOWNLOAD]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
  [MLSID.AGENDA_DOWNLOAD]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
  [MLSID.PARTNER_PROSPECTUS_DOWNLOAD]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
  [MLSID.SAVE_THE_DATE]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
  [MLSID.START_SURVEY]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
  [MLSID.VIDEO_CONTENT]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
  [MLSID.MEDIA_PACKAGE_DOWNLOAD]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
  [MLSID.WHITE_PAPER_DOWNLOAD]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
  [MLSID.PODCAST_CONTENT]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
  [MLSID.WEBAPP_FREETICKET_ONSITE]: {
    component: InboundButton,
    getProps: attributes => ({
      buttonType: attributes.buttontype,
      inboundValues: safeJSONParse(attributes.inboundbuttonattributes),
    }),
  },
};
